import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import ScrollableTable from "../../Common/Table/ScrollableTable";
import CloseIcon from "../../Common/CloseIcon";

import { exportTableToCsv } from "../../../utils/data";

import colors from "../../../assets/style/colors";
import DownloadIcon from "../../Common/DownloadIcon";

const styles = {
  dialogPaper: {
    minWidth: "768px",
    maxWidth: "calc(100vw - 100px)",
    padding: "12px 0px 0px",
    height: "calc(100vh - 30px)",
    maxHeight: "unset",
  },
  closeIcon: {
    paddingRight: "12px",
    display: "flex",
    justifyContent: "flex-end",
  },
  tableContainer: {
    padding: "0px",
    minWidth: "768px",
    maxWidth: "calc(100vw - 100px)",
    overflow: "auto",
    maxHeight: "calc(100vh - 108px)",
    marginTop: "6px",
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    paddingLeft: "10px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const HspSecondaryDialog = (props) => {
  const {
    classes,
    open,
    setOpen,
    title,
    fetchData,
    columns,
    isFetching,
    data,
    dataFunctions,
  } = props;

  return (
    <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
      <Grid container direction="column">
        <Grid item>
          <Grid container alignItems="center">
            <Grid item xs={2} />
            <Grid
              item
              xs
              className="dialogTitle flexCenter"
              style={{ justifyContent: "center" }}
            >
              {title}
            </Grid>
            <Grid item xs={2} className={classes.closeIcon}>
              <CloseIcon closeFunction={() => setOpen(false)} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <DownloadIcon
            exportCsv={() =>
              exportTableToCsv(title, columns, data, dataFunctions, I18n.get)
            }
            style={{ marginLeft: "12px" }}
          />
        </Grid>
        <Grid item className={classes.tableContainer}>
          <ScrollableTable
            fetchData={fetchData}
            columns={columns}
            hasMore={false}
            isFetching={isFetching}
            stickyHeader
          >
            {props.children}
          </ScrollableTable>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default withStyles(styles)(HspSecondaryDialog);
